import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { Tabs } from "@mui/material";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import * as React from 'react';

function a11yProps(index: number) {
	return {
		id: `vertical-tab-${index}`,
		'aria-controls': `vertical-tabpanel-${index}`,
	};
}

export default function MUITabs() {
	const [value, setValue] = React.useState('1');
	
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	
	return (
			<TabContext value={value}>
				<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
					<TabList onChange={handleChange} aria-label="tabs">
						<Tab label={'hi tab'} value="1"/>
						<Tab label={'ho tab'} value="2"/>
					</TabList>
				</Box>
				<TabPanel value="1">
					lorem ipsum dolor sit amet, consectetur adipiscing elit.
				</TabPanel>
				<TabPanel value="2">
					lorem ipsum dolor sit amet, consectetur adipiscing elit. lorem ipsum dolor sit amet, consectetur
					adipiscing elit.
				</TabPanel>
			</TabContext>
	// 	TODO::Vertical Tabs
	);
}
